/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { FileAddFileUploadResponse } from "./FileAddFileUploadResponse";

export type FileAddFileUploadResponseApiRespoonse = {
  data?: FileAddFileUploadResponse;
  status?: FileAddFileUploadResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace FileAddFileUploadResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
